module.exports = __webpack_public_path__ + "static/media/ic_product_robotrader_info_three.b624eb00.svg";